
<svg
  fill="currentColor"
  width="24"
  height="24"
  viewBox="0 0 24 24"><g transform="translate(10620 -4298)"><path d="M0,0H24V24H0Z" transform="translate(-10620 4298)" fill="none"/><g transform="translate(2.28)"><path d="M3,15H13.6V13H3Zm0,4H13.6V17H3Zm0-8H13.6V9H3ZM3,5V7H13.6V5Z" transform="translate(-10618.579 4298)"/><rect width="18" height="2" transform="translate(-10617.28 4319) rotate(-90)"/><rect width="18" height="2" transform="translate(-10605.28 4319) rotate(-90)"/></g></g></svg>
